export const i18nContentHash = 'f37049e'
